// extracted by mini-css-extract-plugin
export default {"container":"index-container___3FrxQ"};